export default "__VITE_ASSET__CrkGzDR___"